<template>
  <div>
     
  </div>
</template>
<script>
import md5 from 'md5'
  export default {
    methods: {
      goToRulebook() {
        const userInfo = this.userInfo || {};
        if(userInfo.Mail_Address){
          this.DSSAccount()
        }else{
          let hashEmail = userInfo.Mail_Address ? md5(userInfo.Mail_Address) : '';
          if (!hashEmail && userInfo.Mail_Address) {
            hashEmail = md5(userInfo.Mail_Address);
          }

          if (this.userInfo.Name) {
            const hashId = userInfo.Emp_code ? md5(userInfo.Emp_code) : '';
            window.open(`https://documentsearch.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
            this.$router.push('/');
          } else if (this.userInfo.Name) {
            const hashId = userInfo.Emp_code ? md5(userInfo.Emp_code) : '';
            window.open(`https://documentsearch.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
            this.$router.push('/');
          }
        }
      },
      DSSAccount(){
        const userInfo = this.userInfo || {};
        let hashEmail = userInfo.Mail_Address ? md5(userInfo.Mail_Address) : '';
        let hashId = this.formatEmpCode(userInfo.Emp_code) ? md5(this.formatEmpCode(userInfo.Emp_code)) : '';
        window.open(`https://documentsearch.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
        this.$router.push('/');
      },
      formatEmpCode(empCode) {
        if(empCode){
          const trimmedEmpCode = empCode.replace(/^0+/, '');
          return trimmedEmpCode;
        }else{
          return empCode
        }
      }
    },
    mounted() {
      this.goToRulebook()
    },
    computed: {
      userInfo() {
        return this.$root.decryptedUser;
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>